<template>
  <!-- eslint-disable vue/no-v-html -->
  <tr class="compareTableRow">
    <td>
      {{ title }}
    </td>
    <td
      ref="textOne"
      class="whitespace-prewrap"
      name="textOne"
      v-html="text1"
    />
    <td
      ref="textTwo"
      class="whitespace-prewrap"
      name="textTwo"
      v-html="text2"
    />
    <td
      ref="diff"
      class="whitespace-prewrap"
      name="diff"
      v-html="comparedText"
    />
  </tr>
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
export default {
  props: {
    order: {
      type: Number,
      required: false,
      default: 0,
    },
    tenant: {
      type: [String, Number],
      required: false,
      default: null,
    },
    text1: {
      type: String,
      required: false,
      default: "",
    },
    text2: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      comparedText: "",
    };
  },
  watch: {
    text1() {
      setTimeout(() => {
        this.comparedText = this.getDiffHtml();
        this.createDiffOutput();
      }, 100);
    },
    text2() {
      setTimeout(() => {
        this.comparedText = this.getDiffHtml();
        this.createDiffOutput();
      }, 100);
    },
  },
  mounted() {
    this.comparedText = this.getDiffHtml();
    setTimeout(() => {
      this.createDiffOutput();
    }, 50);
  },
  methods: {
    getDiffHtml() {
      var baseText = this.$refs["textOne"]
        ? this.$refs["textOne"].innerText
        : "";
      var newText = this.$refs["textTwo"]
        ? this.$refs["textTwo"].innerText
        : "";
      baseText = baseText || "";
      newText = newText || "";

      var hasDifferences = false;

      // eslint-disable-next-line
      var dmp = new diff_match_patch();

      var d = dmp.diff_main(baseText, newText);
      dmp.diff_cleanupSemantic(d);

      d.forEach(function (item) {
        if (item[0] != 0) {
          hasDifferences = true;
        }
      });

      if (hasDifferences) {
        var ds = dmp.diff_prettyHtml(d);
        return ds;
      } else {
        return "";
      }
    },
    createDiffOutput() {
      if (
        !this.$refs["textOne"] ||
        !this.$refs["textTwo"] ||
        !this.$refs["diff"]
      ) {
        return;
      }

      var compareObject = {
        order: this.order,
        textOne: this.$refs["textOne"].innerHTML,
        textOneInnerText: this.$refs["textOne"].innerText,
        textTwo: this.$refs["textTwo"].innerHTML,
        textTwoInnerText: this.$refs["textTwo"].innerText,
        diff: this.comparedText,
        diffText: this.$refs["diff"].innerText,
        title: this.title,
        tenant: this.tenant,
      };

      this.$emit("comparisonFinished", compareObject);
    },
  },
};
</script>

<style>
.compareTableRow .criterionWrapper table {
  overflow: auto;
  display: block;
  width: 100%;
}
</style>

<style scoped>
.whitespace-prewrap {
  white-space: pre-wrap;
}
</style>
